module.exports = __webpack_public_path__ + "img/SI5496527.d26ff2ae.png";